/**
 * Cadastro duplicado por telefone (caso Amanda / Dulcinea): em vez de só toast,
 * localiza o contato existente e abre histórico (ou compose).
 */
import ContactAPI from 'dashboard/api/contacts';
import { useAlert } from 'dashboard/composables';
import { openContactChatOrCompose } from './openLatestConversation';

/** Normaliza telefone para comparação (só dígitos; mantém + na busca API). */
export function normalizePhoneDigits(phone) {
  if (!phone) return '';
  return String(phone).replace(/\D/g, '');
}

/** Igualdade de dígitos ou sufixo (ex.: 12988542342 vs 5512988542342). */
export function phoneDigitsMatch(a, b) {
  if (!a || !b) return false;
  if (a === b) return true;
  return a.endsWith(b) || b.endsWith(a);
}

/**
 * @param {string} phoneNumber E.164 ou dígitos
 * @returns {Promise<object|null>} contato camelCase/snake do payload search
 */
export async function findContactByPhoneNumber(phoneNumber) {
  const digits = normalizePhoneDigits(phoneNumber);
  if (!digits) return null;

  const candidates = [
    phoneNumber.startsWith('+') ? phoneNumber : `+${digits}`,
    digits,
    digits.startsWith('55') ? `+${digits}` : `+55${digits}`,
  ];

  for (const q of [...new Set(candidates)]) {
    try {
      const { data } = await ContactAPI.search(q);
      const payload = data?.payload || [];
      const match = payload.find(c => {
        const phone = c.phone_number || c.phoneNumber || '';
        return phoneDigitsMatch(normalizePhoneDigits(phone), digits);
      });
      if (match) return match;
    } catch {
      /* tenta próximo candidato */
    }
  }

  return null;
}

/**
 * @returns {Promise<'opened'|'compose'|'no_access'|'error'|'not_found'>}
 */
export async function openExistingContactOnPhoneDuplicate({
  phoneNumber,
  accountId,
  router,
  t,
  alertKey = 'CONTACT_FORM.FORM.PHONE_NUMBER.DUPLICATE_OPENING',
}) {
  const contact = await findContactByPhoneNumber(phoneNumber);
  if (!contact?.id) {
    useAlert(
      t('CONTACT_FORM.FORM.PHONE_NUMBER.DUPLICATE') ||
        'Este número de telefone está em uso para outro contato.'
    );
    return 'not_found';
  }

  useAlert(t(alertKey));
  return openContactChatOrCompose({
    contactId: contact.id,
    accountId,
    router,
    t,
  });
}
